module.exports = __webpack_public_path__ + "static/media/icn_application_created.edaca7b6.svg";